<template>
  <BasicLayout>
    <template #wrapper>
      <el-card :bordered="false" :body-style="{padding: '0'}">

        <div class="salesCard">
          <el-form :inline="true">
            <el-form-item label="开始日期">
              <el-date-picker
                v-model="queryParams1.startDate"
                placeholder="请选择日期"
                clearable
                value-format="yyyy-MM-dd"
                type="date"
                size="small"
                @keyup.enter.native="handleQuery"
              />
            </el-form-item>
            <el-form-item label="结束日期">
              <el-date-picker
                v-model="queryParams1.endDate"
                placeholder="请选择日期"
                clearable
                value-format="yyyy-MM-dd"
                type="date"
                size="small"
                @keyup.enter.native="handleQuery"
              />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery(0)">查询</el-button>
              <!--              <el-button v-if="isExport" type="primary" icon="el-icon-download" size="mini" @click="handleQuery(1)">导出</el-button>-->
            </el-form-item>
          </el-form>
          <div ref="chartContainer" style="width: 100%; height: 400px;" />
        </div>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import echarts from 'echarts'
import { getNotBuildStat } from '@/api/statistics/user_remain'
import { dateStrTodate, getLastDates } from '@/utils'
export default {
  name: 'IndexNotBuildStat',
  props: {
    isExport: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      chartData: {},
      queryParams1: {
        startDate: '',
        endDate: '',
        type: 1,
        level: 0
      }
    }
  },
  created() {
    this.queryParams1.startDate = getLastDates(7)
    this.queryParams1.endDate = getLastDates(1)
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  methods: {
    handleQuery(isExport = 0) {
      if (!this.queryParams1.startDate) {
        this.msgError('开始日期不能为空')
        return
      }

      if (!this.queryParams1.endDate) {
        this.msgError('结束日期不能为空')
        return
      }
      this.initChart(isExport)
    },
    initChart(isExport = 0) {
      const chart = echarts.init(this.$refs.chartContainer)
      const option = {
        color: ['#00BFFF', '#FF69B4', '#FF7F50', '#BA55D3', '#FFA500', '#7B68EE'],
        title: {
          text: '未建造占比'
        },
        xAxis: {
          name: '日期',
          type: 'category',
          data: []
        },
        legend: {
          data: ['每天有钱不过关', '每天钱多没被偷', '历史有钱不过关', '历史有钱没被偷'],
          x: 'center',
          y: 'bottom'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value}' // 使用默认的数值格式
          },
          axisLine: {
            show: false // 隐藏 y 轴的竖线
          }
        },
        toolbox: {
          show: true,
          feature: {
            // dataView: { readOnly: false },
            // magicType: { type: ['line', 'bar'] },
            // restore: {},
            // saveAsImage: {}
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        series: [
          {
            name: '每天有钱不过关',
            data: [],
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}%' // 显示数值
            }
          },
          {
            name: '每天钱多没被偷',
            data: [],
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}%' // 显示数值
            }
          },
          {
            name: '历史有钱不过关',
            data: [],
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}%' // 显示数值
            }
          },
          {
            name: '历史有钱没被偷',
            data: [],
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}%' // 显示数值
            }
          }
        ]
      }
      chart.setOption(option)
      chart.showLoading()
      this.loading = true
      setTimeout(() => {
        // this.queryParams1.level = 0
        // if (isExport) {
        // this.queryParams1.level = 1
        // }
        getNotBuildStat(this.queryParams1).then(res => {
          this.loading = false
          chart.hideLoading()
          if (res.code === 200) {
            // this.queryParams1.startDate = res.data.req.startDate
            // this.queryParams1.endDate = res.data.req.endDate
            // if (this.queryParams1.level === 1) {
            //   window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
            // }

            if (res.data.length < 1) {
              return
            }
            const date = []
            const loginNotBuild = []
            const loginMoneyNotBuild = []
            const historyLogNotBuild = []
            const historyMoneyLogNotBuild = []
            res.data.forEach(item => {
              date.push(dateStrTodate(item.date))
              loginNotBuild.push(item.login_pct) // 登录不建造
              loginMoneyNotBuild.push(item.steal_pct) // 登录未被偷
              historyLogNotBuild.push(item.all_pct) // 历史有钱不过关
              historyMoneyLogNotBuild.push(item.all_steal_pct) // 历史有钱没被偷
            })

            option.xAxis.data = date
            option.series[0].data = loginNotBuild
            option.series[1].data = loginMoneyNotBuild
            option.series[2].data = historyLogNotBuild
            option.series[3].data = historyMoneyLogNotBuild
            // chart.hideLoading()
            chart.setOption(option, true)
          } else {
            this.msgError(res.msg)
          }
        })
      }, 800)
    }
  }
}
</script>

  <style scoped />
